import React, { useCallback, useEffect, useRef } from 'react'
import Select from "react-select";
import { Fragment, useState } from 'react'
import { createRoot } from 'react-dom/client';
import * as XLSX from 'xlsx';
import { SlLocationPin } from "react-icons/sl";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { GoCircle } from "react-icons/go";
import { IoClose } from "react-icons/io5";
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { GET_ORDER_COUNT, GET_ORDERS, GET_ORDERS_BY_ID } from '../graphql/Query/Order.js';
import { CREATE_PAYMENT_REFUND } from '../graphql/Mutation/paymentRefund.js'
import moment from 'moment';
import NoDataFound from '../components/NoDataFound.js';
import { toast } from 'react-toastify';
import { CANCEL_ORDER } from '../graphql/Mutation/Ordre.js';
import { useModal } from '../Contex.js';
import { GET_ROLE_USER } from '../graphql/Query/Signin.js';
import Label from '../Home/Label.js';
import CustomPagination from '../components/Pagination.js';
import SpinLoader from '../components/SpinLoader.js';
import useScrollToTop from '../components/useScrollToTop.js';
import { MdContentCopy } from "react-icons/md";
import { BsBox } from 'react-icons/bs';
import CustomLabel from '../Common/CustomLabel.js';
import { allowedPincodes } from './PincodeService.js';
import { typeOptions } from '../SuperAdminPanel/AdminTodayOrder.js';
import Loader from '../components/Loader.js';
// import { handleDownload } from '../Common/DownloadLabel.js';
import SideBar from './SideBar.js';
import { FaChevronDown, FaSyncAlt } from "react-icons/fa";
import { FiDownload, FiFilter, FiX } from "react-icons/fi";
import DateFilter from '../Common/DateRange.js';
import { getDateRange } from '../Common/GetDateRange.js';



const channelOptions = [
    { value: "All", label: "All Channels" },
    { value: "Custom", label: "Custom" },
];


const CreatShiment = [
    { value: "create", label: "Create Order", link: "/documentshipping" },
    // { value: "bulk", label: "Bulk Create Order", link: " /bulkcourier" },
];


const options = [
    "Pending RTO",
    "RTO",
    // "RTO Delivered",
    // "RTO Lost",
    // "RTO Damaged",
    "RTO In Transit",
    "RTO Reached at Destination",
    "RTO Delivered",
    "Misrouted",
    "Exception",
    "Lost",
    "Damaged",
];


const warehouseOptions = [
    { value: "All", label: "All Warehouses" },
];

export const capitalizeFirstLetter = (text) => {
    if (!text) return text;
    return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};
const AllOrders = () => {
    useScrollToTop();


    // const invoiceRef = useRef(null);
    // const [open, setOpen] = useState(false)
    // const [selectedLabel, setSelectedLabel] = useState('');
    // const [singlePageId, setsinglePageId] = useState('');
    // const [modalOpenedOnce, setModalOpenedOnce] = useState(false);
    const { setModalOpen } = useModal();
    const [searchUser, setSearchUser] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [copySuccess, setCopySuccess] = useState({});
    const [filter, setFilter] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    // const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
    const [activeButton, setActiveButton] = useState('All Courier');
    const location = useLocation();
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [orderData, setOrderData] = useState([]);
    const [activeTab, setActiveTab] = useState("All");
    const [orderStatus, setorderStatus] = useState('');
    const [selectedPaymentType, setSelectedPaymentType] = useState('');
    const [GetOrderOrderData, { loading: loadingDataDownload }] = useLazyQuery(GET_ORDERS_BY_ID, {
        fetchPolicy: "cache-and-network"
    });
    const [singleOrderLabel, setSingleOrderLabel] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [showFilters, setShowFilters] = useState(true);
    const [selectedMoreOption, setSelectedMoreOption] = useState("");
    const dataLocation = location?.state?.data
    const [addPaymentRefund] = useMutation(CREATE_PAYMENT_REFUND);
    const { data: getUser, refetch: getUserRoleRefetch } = useQuery(GET_ROLE_USER, {
        fetchPolicy: "cache-and-network"
    });
    const [finalRange, setFinalRange] = useState({
        filterType: "Last 7 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const [fetchAllOrders] = useLazyQuery(GET_ORDERS, {
        fetchPolicy: "cache-and-network"
    });

    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_ORDERS, {
        variables: {
            page: page + 1,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            // customerId: getUser?.me?.id || idData,
            tag: activeButton,
            "filter": filter?.trim(),
            from: finalRange?.startDate?.toISOString(), // Use updated startDate
            to: finalRange?.endDate?.toISOString(),
            orderStatus: orderStatus,
            paymentType: selectedPaymentType
        },
        fetchPolicy: "cache-and-network",
    });

    const { data: countData, refetch: refetchCount } = useQuery(GET_ORDER_COUNT, {
        variables: {
            tag: activeButton,
            "filter": filter?.trim(),
            from: finalRange?.startDate?.toISOString(),
            to: finalRange?.endDate?.toISOString(),
            paymentType: selectedPaymentType,
            orderStatus: orderStatus,
        },
        fetchPolicy: "cache-and-network",
    })

    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);


    // Destructure the final range to pass to the query

    const navigate = useNavigate();
    const handleChange = (selectedOption) => {
        if (selectedOption?.link) {
            navigate(selectedOption?.link.trim(), { replace: true });
        }
    };
    const handleTabClick = (tab) => {
        // console.log('✌️tab --->', tab);
        setActiveTab(tab);
        if (tab === 'All') {
            setorderStatus('');
        } else if (tab === 'Cancelled') {
            setorderStatus('Cancelled');
        } else if (tab === 'Pickup Done') {
            setorderStatus('Pickup Done');
        } else if (tab === 'In Transit') {
            setorderStatus('In Transit');
        } else if (tab === 'Out for Delivery') {
            setorderStatus('Out for Delivery');
        } else if (tab === 'Delivered') {
            setorderStatus('Delivered');
        } else if (tab === 'RTO') {
            setorderStatus('RTO');
        } else if (tab === 'RTO Delivered') {
            setorderStatus('RTO Delivered');
        } else if (tab === 'Booked') {
            setorderStatus('Booked');
        } else if (tab === 'Reached at Destination') {
            setorderStatus('Reached at Destination');
        } else if (tab === 'Exception') {
            setorderStatus('Exception');
        } else if (tab === 'Pending RTO') {
            setorderStatus('Pending RTO');
        } else if (tab === 'RTO Reached at Destination') {
            setorderStatus('RTO Reached at Destination');
        } else if (tab === 'Misrouted') {
            setorderStatus('Misrouted');
        } else if (tab === 'RTO In Transit') {
            setorderStatus('RTO In Transit');
        } else {
            setorderStatus('');
        }
        refetchCount();
        setSelectedMoreOption("");
    };
    const handleDropdownSelect = (option) => {
        setSelectedMoreOption(option);
        setActiveTab(option); // Highlight active tab from dropdown
        setIsOpen(false);
        setorderStatus(option);
    };
    // useEffect(() => {
    //     if (location.state?.shouldRefetch) {
    //         refetch();
    //         setOpen(true);
    //     }
    // }, [location.state, refetch]);
    // useEffect(() => {
    //     const hasModalOpened = localStorage.getItem('modalOpenedOnce');
    //     // console.log('✌️hasModalOpened --->', hasModalOpened);
    //     // console.log('✌️location.state?.shouldRefetch --->', location.state?.shouldRefetch);
    //     if (location.state?.shouldRefetch && !hasModalOpened) {
    //         refetch().then((response) => {
    //             // console.log('✌️response --->', response);
    //             // Check if there's data and get the label from the first item
    //             const latestOrder = response.data?.getOrders?.data?.[0];
    //             if (latestOrder && latestOrder?.label) {
    //                 // console.log('✌️latestOrder --->', latestOrder);
    //                 setSelectedLabel(latestOrder?.label);
    //                 setsinglePageId(latestOrder?.id)
    //             }
    //             setOpen(true); // Open the modal
    //             localStorage.setItem('modalOpenedOnce', 'true');
    //         });
    //     }
    // }, [location?.state]);
    useEffect(() => {
        if (GetOrderOrder?.getOrders?.data) {
            setOrderData(GetOrderOrder?.getOrders?.data);
        }
    }, [GetOrderOrder]);

    const handleDownloadLabel = async (id) => {
        // console.log('✌️id --->', id);
        const GetOrderOrderDataValue = await GetOrderOrderData({
            variables: {
                "getOrderId": id,
            },
        });

        // console.log('✌️GetOrderOrderDataValue --->', GetOrderOrderDataValue);
        setSingleOrderLabel(GetOrderOrderDataValue?.data?.getOrder);

    };
    useEffect(() => {
        const generatePDF = async () => {
            if (!singleOrderLabel) return;

            const doc = new jsPDF("p", "pt", [285, 437]); // 4x6 inches
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-9999px";
            container.style.visibility = "visible";
            document.body.appendChild(container);

            const root = createRoot(container);
            root.render(<CustomLabel key={singleOrderLabel?._id} order={singleOrderLabel} />);

            await new Promise((resolve) => setTimeout(resolve, 500));

            try {
                const canvas = await html2canvas(container, { scale: 2 });
                const imgData = canvas.toDataURL("image/png");
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                doc.save(`${singleOrderLabel?.order_number}.pdf`);
                setSingleOrderLabel()
            } catch (error) {
                console.error("Error generating label:", error);
            }

            root.unmount();
            document.body.removeChild(container);
        };

        generatePDF();
    }, [singleOrderLabel]);



    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(0);

    }

    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';

            return {
                No: index + 1,
                // "Order ID": shipment?.order_id,
                "Order Date": moment(shipment?.createdAt).format('DD/MM/YYYY'),
                AWB: shipment?.awb_number,
                "COD Collectable Amount": shipment?.payment_type === 'cod' ? `₹${shipment?.ProductPrice}` : 0,
                "Order Amount": `₹${shipment?.ProductPrice}`,
                "Payment Type": shipment?.payment_type,
                "First Name": shipment?.deliveryAddress?.name,
                "Phone": shipment?.deliveryAddress?.phone,
                Address: fullAddress,
                City: city,
                State: state,
                "Pincode": zipCode,
                "Weight (Kg)": shipment?.package_weight,
                Status: shipment?.status,
                "SKU(1)": shipment?.order_number,
                Product: shipment?.ProductName,

            };
        });
    };

    const downloadExcel = async () => {
        const { data } = await fetchAllOrders({
            variables: {
                page: 1,
                limit: 100000,
                "sort": {
                    "key": "createdAt",
                    "type": -1
                },
                tag: activeButton,
                "filter": filter.trim(),
                from: finalRange?.startDate?.toISOString(), // Use updated startDate
                to: finalRange?.endDate?.toISOString(),
                orderStatus: orderStatus,
                paymentStatus: selectedPaymentType,
            },
            fetchPolicy: "cache-and-network"
        });

        if (!data?.getOrders?.count) {
            toast.error("No data available for export")
            return;
        }

        // Transform data for export
        const transformedData = transformDataForExport(data?.getOrders?.data);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Order");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "Order.xlsx");
    };

    useEffect(() => {
        if (dataLocation) {
            if (dataLocation === 'To me' || dataLocation === 'From me') {
                !getUser?.me?.mobile && setModalOpen(true);
            }
            setActiveButton(dataLocation);
        }
    }, [dataLocation]);


    const handleCopy = (awbNumber, index) => {
        // Use the Clipboard API to copy the text
        navigator.clipboard.writeText(awbNumber)
            .then(() => {
                setCopySuccess((prev) => ({
                    ...prev,
                    [index]: true,
                }));
                setTimeout(() => {
                    setCopySuccess((prev) => ({
                        ...prev,
                        [index]: false,
                    }));
                }, 2000);
            })
            .catch(err => {
                // console.error('Failed to copy text: ', err);
            });
    };



    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        // refetch(); // Refetch data with the new page
    };
    const resetData = () => {
        setPage(0);
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setSelectedPaymentType('');
        setActiveTab('All')
        const defaultRange = getDateRange("Last 7 Days");
        setFinalRange({
            filterType: "Last 7 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 7 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });
    }

    return (
        <>
            <Header />
            <div className="flex bg-slate-100 min-h-screen">
                <div>
                    <SideBar />
                    {/* <Transition show={mobileFiltersOpen}>
                        <Dialog className="relative z-40 lg:hidden" onClose={setMobileFiltersOpen}>
                            <TransitionChild
                                enter="transition-opacity ease-linear duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="transition-opacity ease-linear duration-300"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                            </TransitionChild>

                            <div className="fixed inset-0 z-40 flex">
                                <TransitionChild
                                    enter="transition ease-in-out duration-300 transform"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transition ease-in-out duration-300 transform"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <DialogPanel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 ">
                                        <div className="flex items-center justify-between px-4">
                                            <h2 className="text-lg font-medium text-gray-900">Filters</h2>
                                            <button
                                                type="button"
                                                className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400"
                                                onClick={() => setMobileFiltersOpen(false)}
                                            >
                                                <span className="sr-only">Close menu</span>
                                                <IoClose className="h-6 w-6" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </TransitionChild>
                            </div>
                        </Dialog>
                    </Transition> */}

                    <main className="mx-auto max-w-auto px-0 py-6 md:p-6 ml-16">

                        {/* <div className="p-6 mt-8 bg-white border rounded-lg flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
                           
                            <p className="font-bold text-center md:text-left text-gray-800">
                                Shipment and Payment Details
                            </p>

                          
                            <div className="flex flex-wrap justify-center lg:justify-end space-x-4">
                                <Link to='/allorderseller'> <button className=" mb-1 px-6 py-2 bg-slate-800 text-white font-semibold rounded-lg hover:bg-slate-900 text-sm focus:outline-none ">
                                    All Shipment
                                </button></Link>
                                <Link to='/allpaymentseller'><button className=" px-6 py-2 bg-slate-800 text-white font-semibold rounded-lg hover:bg-slate-900 text-sm focus:outline-none ">
                                    COD Payment
                                </button></Link>
                            </div>
                        </div> */}


                        <div className="p-4 md:p-6 mt-1 bg-white border rounded-lg space-y-6">
                            {/* Header Section */}
                            <div className="flex flex-col md:flex-row items-center justify-between gap-3 w-full">
                                <h1 className="text-xl font-bold text-left w-full md:w-auto">All Orders</h1>
                                <div className="w-full sm:w-60 md:w-40">
                                    <Select
                                        options={CreatShiment}
                                        classNamePrefix="react-select"
                                        placeholder="Create Order"
                                        onChange={handleChange}
                                        isSearchable={false}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: "#fff",
                                                color: "#000",
                                                height: "36px", // Adjust height for better visibility
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                borderRadius: "8px",
                                                border: "1px solid #dbdbdb",
                                                "&:hover": { border: "1px solid #c9c9c9" },
                                                boxShadow: "none",
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: "#000",
                                                fontWeight: "500",
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                padding: "4px 0",
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                color: "#000",
                                                padding: "6px 12px",
                                                cursor: "pointer",
                                                backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                                "&:hover": { backgroundColor: "#f0f0f0" },
                                            }),
                                            dropdownIndicator: (provided) => ({
                                                ...provided,
                                                color: "#000",
                                                "&:hover": { color: "#000" },
                                            }),
                                            indicatorSeparator: () => ({
                                                display: "none",
                                            }),
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 w-full">
                                <div className='md:block hidden'>
                                    <div className="flex items-center gap-3 w-full lg:w-auto">
                                        <BsBox className="text-2xl text-gray-900 drop-shadow-md" />
                                        <h1 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                                            Domestic Shipment Services Across India
                                        </h1>
                                    </div></div>
                                <div className='block md:hidden'>
                                    <div className="flex gap-3 w-full lg:w-auto">
                                        <BsBox className="text-2xl hidden md:block text-gray-900 drop-shadow-md" />
                                        <h1 className="text-lg font-bold text-gray-800 md:text-left">
                                            Domestic Shipment Services Across India
                                        </h1>
                                    </div>
                                </div>
                                <div className="flex flex-col sm:flex-row flex-wrap justify-Start lg:justify-end gap-3 w-full">

                                    <button onClick={() => window.location.reload()} className="flex items-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full md:w-auto">
                                        <FaSyncAlt /> Refresh
                                    </button>
                                    <button onClick={downloadExcel} className="flex items-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full md:w-auto">
                                        <FiDownload className="text-lg" /> Export
                                    </button>
                                    <button
                                        onClick={() => setShowFilters(!showFilters)}
                                        className="flex items-center gap-2 text-sm px-4 py-1.5 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full md:w-auto"
                                    >
                                        {showFilters ? <FiX className="text-lg" /> : <FiFilter className="text-lg" />}
                                        {showFilters ? "Close" : "Filter"}
                                    </button>
                                </div>
                            </div>

                            {/* Filter Section */}
                            {showFilters && (
                                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                                    {/* Custom Search */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Custom Search</label>
                                        <input
                                            type="text"
                                            value={searchUser}
                                            onChange={(e) => { setSearchUser(e.target.value); handleSearch(e); }}
                                            placeholder="Search..."
                                            className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>
                                    {/* Shipment IDs */}
                                    {/* <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Customer</label>
                                        <input
                                            type="text"
                                            value={filterOrder}
                                            onChange={(e) => { handleSearch(e, 'orderId'); }}
                                            placeholder="Customer Name"
                                            className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div> */}
                                    {/* AWB No. */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">AWB No.</label>
                                        <input
                                            type="text"
                                            value={awbNumber}
                                            onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber'); }}
                                            placeholder="AWB Nos (comma-separated)"
                                            className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>
                                    {/* Payment Type */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Payment Type</label>
                                        <Select
                                            options={typeOptions}
                                            defaultValue={typeOptions[0]}
                                            className="w-full"
                                            value={typeOptions.find(option => option?.value === selectedPaymentType) || null}
                                            onChange={(selectedOption) => setSelectedPaymentType(selectedOption?.value)}
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                    '&:hover': { borderColor: '#64748B' },
                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                    borderRadius: '0.375rem',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                    color: state.isSelected ? '#000000' : '#000000',
                                                    fontSize: '0.875rem',
                                                    '&:hover': {
                                                        backgroundColor: '#cbd5e1',
                                                        color: '#000000',
                                                        fontSize: '0.875rem',
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '14px',
                                                    color: '#A3AAB5',
                                                    fontSize: '0.875rem',
                                                }),
                                            }}
                                        />
                                    </div>

                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                        <DateFilter onDateChange={handleDateChange} defaultFilterType={finalRange?.filterType} />
                                    </div>
                                    <div className="flex items-end h-full" onClick={resetData}>
                                        <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400">
                                            Reset Filters
                                        </p>
                                    </div>
                                </div>
                            )}

                            {/* Tab Section */}
                            <div className="border-t">
                                <div className="flex flex-wrap gap-4 mt-4">
                                    {[
                                        { name: "All" },
                                        { name: "Pickup Done", count: countData?.getOrderStatusCounts?.statusCounts?.PickupDone || 0 },
                                        { name: "Booked", count: countData?.getOrderStatusCounts?.statusCounts?.Booked || 0 },
                                        { name: "In Transit", count: countData?.getOrderStatusCounts?.statusCounts?.InTransit || 0 },
                                        { name: "Reached at Destination", count: countData?.getOrderStatusCounts?.statusCounts?.ReachedatDestination || 0 },
                                        { name: "Out for Delivery", count: countData?.getOrderStatusCounts?.statusCounts?.OutforDelivery || 0 },
                                        { name: "Delivered", count: countData?.getOrderStatusCounts?.statusCounts?.Delivered || 0 },
                                        { name: "Cancelled", count: countData?.getOrderStatusCounts?.statusCounts?.Cancelled || 0 },
                                    ].map(({ name, count }) => (
                                        <button key={name} onClick={() => handleTabClick(name)}
                                            className={`px-4 py-1 text-sm shadow-md font-medium rounded-md ${activeTab === name ? "bg-slate-900 text-white" : "bg-white text-gray-700 border border-gray-300 hover:bg-slate-100"
                                                }`}>
                                            {name} {name === 'All' ? "" : `(${count})`}
                                        </button>
                                    ))}

                                    <div className="relative inline-block text-left">

                                        <div className="relative inline-block text-left">
                                            <button
                                                onClick={() => setIsOpen(!isOpen)}
                                                className={`flex items-center justify-between px-4 py-1 shadow-md text-sm font-medium rounded-lg transition border ${selectedMoreOption ? "bg-slate-900 text-white border-slate-900" : "bg-white text-gray-700 border-gray-300 hover:bg-slate-100"
                                                    }`}
                                            >
                                                {selectedMoreOption || "More"} <FaChevronDown className="ml-2 text-xs" />
                                            </button>


                                            {isOpen && (
                                                <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg ">
                                                    <ul className="py-2">
                                                        {options?.map((option, index) => (
                                                            <li
                                                                key={index}
                                                                className="px-4 py-2 text-gray-700 hover:bg-slate-100 cursor-pointer"
                                                                onClick={() => handleDropdownSelect(option)}
                                                            >
                                                                {option}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <section aria-labelledby="products-heading" className="md:pb-2 md:pt-6">
                            <h2 id="products-heading" className="sr-only">
                                Products
                            </h2>

                            <div className="grid grid-cols-1 gap-x-8 gap-y-3 lg:grid-cols-4">
                                <div className="space-y-4 border-b border-gray-200 pb-6 text-sm font-medium text-gray-900">
                                    <div className=' hidden lg:block py-3 bg-white rounded-lg px-4 cursor-pointer'>
                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"To Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "To Me," it means that the shipment is being sent to you.
                                                Someone else (the sender) has created an order or package and is shipping it to your address.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you order a product online and the seller sends the package to your home or office,
                                                that shipment is "To Me." You are the recipient of the Shipment.
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"From Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "From Me," it means that you are the one sending the shipment
                                                to someone else. You create the Shipment, prepare the package, and arrange for the Shipment to deliver it to the recipient.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you need to send a document to a client or a package to a friend, you create the
                                                shipment, label it, and the Shipment delivers it to the recipient. In this case, the shipment is "From Me."
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">Application in a Shipment Business</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Tracking:</strong> You may need to track both incoming and outgoing shipments...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Customer Service:</strong> When interacting with customers, it’s important to clarify...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Logistics Management:</strong> Managing the flow of shipments in both directions helps...</li>
                                            </ul>
                                        </section>

                                        <section>
                                            <h2 className="text-lg font-semibold mb-2">Summary</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>To Me:</strong> Refers to shipments sent to you from another sender.</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>From Me:</strong> Refers to shipments you send to another recipient.</li>
                                            </ul>
                                        </section>
                                    </div>
                                </div>

                                <div className="lg:col-span-3 space-y-3 w-full">
                                    <div className="flex bg-white p-2 rounded-lg space-x-5">
                                        <button
                                            className={` ${activeButton === 'All Courier' ? 'bg-slate-900 text-white px-3 py-1 shadow-md rounded-lg text-sm font-semibold' : 'text-sm font-semibold border border-slate-600 px-3 py-1 shadow-md rounded-lg  text-gray-600 hover:bg-slate-50 '}`}
                                            onClick={() => setActiveButton('All Courier')}
                                        >
                                            India's Shipment
                                        </button>
                                        <button
                                            className={` ${activeButton === 'To me' ? 'bg-slate-900 text-white px-3 py-1 shadow-md rounded-lg font-semibold text-sm' : 'text-sm font-semibold border border-slate-600 px-3 py-1 shadow-md rounded-lg  text-gray-600 hover:bg-slate-50 '}`}
                                            onClick={() => {
                                                setActiveButton('To me');
                                                !getUser?.me?.mobile && setModalOpen(true);
                                            }}
                                        >
                                            To me
                                        </button>
                                        <button
                                            className={` ${activeButton === 'From me' ? 'bg-slate-900 text-white px-3 py-1 shadow-md rounded-lg font-semibold text-sm' : 'text-sm font-semibold border border-slate-600 px-3 py-1 shadow-md rounded-lg  text-gray-600 hover:bg-slate-50'}`}
                                            onClick={() => {
                                                setActiveButton('From me');
                                                !getUser?.me?.mobile && setModalOpen(true);
                                            }}
                                        >
                                            From me
                                        </button>
                                    </div>
                                    <p className='border-b'></p>

                                    <div className="mt-4">
                                        <>
                                            <div>

                                                {loading &&
                                                    <div className='my-20'>
                                                        <Loader classNamecolor='true' />
                                                    </div>}
                                                {

                                                    orderData?.length > 0 && orderData &&
                                                    orderData.map((data, index) => {
                                                        return (
                                                            <>

                                                                {
                                                                    <div key={index} className='md:p-5 p-2 md:grid md:grid-cols-2 md:space-x-6 grid-cols-1 mb-2 border bg-white border-slate-300 rounded-lg cursor-pointer'>
                                                                        <div className='space-y-4'>
                                                                            <p className={`flex items-center text-md font-semibold ${data?.trackStatus === 'Cancelled' ? 'text-red-500' : 'text-green-500'}`}>
                                                                                <BsBox className="text-2xl me-3" />
                                                                                {data?.trackStatus}
                                                                            </p>
                                                                            <div className='flex space-x-4'>
                                                                                <div className='space-y-1 text-gray-400'>
                                                                                    <GoCircle />
                                                                                    <ul className='ms-1.5'>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3'>I</li>
                                                                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                                                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                                                                    </ul>
                                                                                    <SlLocationPin />
                                                                                </div>
                                                                                {/* {data?.awb_number && <Link to='/singletrack' state={{ id: data?.id, activeButton: activeButton }} >  */}
                                                                                <div className='space-y-4 text-ellipsis overflow-hidden'>
                                                                                    <div>
                                                                                        <p className='text-sm font-semibold mb-1'>
                                                                                            {capitalizeFirstLetter(data?.pickupAddress?.name)}
                                                                                            <span className='ms-1 text-gray-400'>(Pickup)</span>
                                                                                        </p>
                                                                                        <div>
                                                                                            <p className='text-sm'>
                                                                                                {capitalizeFirstLetter(data?.pickupAddress?.address1)}.
                                                                                            </p>
                                                                                            <p className='text-sm'>
                                                                                                {capitalizeFirstLetter(data?.pickupAddress?.city)}. {capitalizeFirstLetter(data?.pickupAddress?.stateId)} - {data?.pickupAddress?.zipCode}
                                                                                            </p>
                                                                                        </div>

                                                                                        <p className='text-sm text-gray-500'>{data?.pickupAddress?.phone}</p>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p className='text-sm font-semibold mb-1'>
                                                                                            {capitalizeFirstLetter(data?.deliveryAddress?.name)}
                                                                                            <span className='ms-1 text-gray-400'>(Delivery)</span>
                                                                                        </p>
                                                                                        <p className='text-sm'>
                                                                                            {capitalizeFirstLetter(data?.deliveryAddress?.address1)}.
                                                                                        </p>
                                                                                        <p className='text-sm'>
                                                                                            {capitalizeFirstLetter(data?.deliveryAddress?.city)}. {capitalizeFirstLetter(data?.deliveryAddress?.stateId)} - {data?.deliveryAddress?.zipCode}
                                                                                        </p>
                                                                                        <p className='text-sm text-gray-500'>{data?.deliveryAddress?.phone}  {data?.deliveryAddress?.alternateMobileNumber ? ` | ${data?.deliveryAddress?.alternateMobileNumber}` : ""}</p>
                                                                                    </div>
                                                                                </div>
                                                                                {/* </Link>
                                                                                } */}
                                                                            </div>
                                                                        </div>
                                                                        <div className='mt-6 md:mt-0 space-y-6'>
                                                                            <div className="md:justify-end justify-start">
                                                                                <div className="flex flex-col items-center  md:justify-end space-y-2 md:space-y-0">
                                                                                    {/* Track Now & More Details Button */}
                                                                                    <div className="flex flex-col md:flex-row items-center justify-between gap-3 w-full">
                                                                                        {/* Buttons Wrapper (Aligned to End) */}
                                                                                        <div className="flex flex-wrap justify-start md:justify-end gap-3 w-full">
                                                                                            {/* Track Now & More Details Button */}
                                                                                            {data?.awb_number && (
                                                                                                <Link to="/singletrack" state={{ id: data?._id, activeButton: activeButton }}>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className={`rounded-md px-4 py-1 text-sm font-semibold text-white transition-all duration-300 ${data?.trackStatus === "Cancelled"
                                                                                                            ? "bg-red-700 hover:bg-red-800"
                                                                                                            : "bg-green-700 hover:bg-green-800"
                                                                                                            }`}
                                                                                                    >
                                                                                                        Track Now & More Details
                                                                                                    </button>
                                                                                                </Link>
                                                                                            )}

                                                                                            {/* Download Label Button */}
                                                                                            {data?.status !== "Cancelled" && (
                                                                                                <button
                                                                                                    className={`rounded-md px-4 py-1 text-sm font-semibold text-white transition-all duration-300 ${data?.trackStatus === "Cancelled"
                                                                                                        ? "bg-red-700 hover:bg-red-800"
                                                                                                        : "bg-green-700 hover:bg-green-800"
                                                                                                        }`}
                                                                                                    onClick={() =>
                                                                                                        // allowedPincodes.includes(data?.pickupAddress?.zipCode)
                                                                                                        // ?
                                                                                                        handleDownloadLabel(data?._id, "label")
                                                                                                        // : handleDownload(data?.label, data?.Shipment_name, data?.awb_number)
                                                                                                    }
                                                                                                    disabled={loading}
                                                                                                >
                                                                                                    Download Label
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>


                                                                                    {/* Download Label Button */}
                                                                                    {/* {data?.awb_number &&
                                                                                        data?.trackStatus === "Your courier has been confirmed" &&
                                                                                        activeButton === "All Courier" && (<>
                                                                                            <div
                                                                                                id={`label-${data?.awb_number}`}
                                                                                                style={{ visibility: "hidden", position: "absolute", top: "-9999px" }}
                                                                                            >
                                                                                                <CustomLabel order={data} />
                                                                                            </div>
                                                                                            <button
                                                                                                // onClick={() => handleDownloadLabel(data?.awb_number)}
                                                                                                // onClick={() => handleDownload(data?.label)}
                                                                                                type="button"
                                                                                                className="rounded-md px-3 py-1.5 text-sm font-semibold text-white bg-green-600 hover:bg-green-700 mt-2 md:mt-0"
                                                                                            >
                                                                                                Download Label
                                                                                            </button>
                                                                                        </>
                                                                                        )} */}
                                                                                </div>

                                                                            </div>

                                                                            <div className="p-5 bg-slate-50 rounded-lg w-full">
                                                                                {/* Payment Type */}
                                                                                <p className="font-bold text-sm uppercase text-gray-700">{data?.payment_type}</p>

                                                                                {/* Shipment Details */}
                                                                                <div className="mt-3 space-y-2">
                                                                                    {/* Shipment ID */}
                                                                                    {/* <div className="flex items-center text-sm text-gray-600">
                                                                                        <span className="w-36 font-medium">Shipment ID:</span>
                                                                                        <span>{data?.order_id ? data?.order_id : "-"}</span>
                                                                                    </div> */}

                                                                                    {/* Shipment No */}
                                                                                    <div className="flex items-center text-sm text-gray-600">
                                                                                        <span className="w-36 font-medium">Shipment No:</span>
                                                                                        <span>{data?.order_number ? data?.order_number : "-"}</span>
                                                                                    </div>

                                                                                    {/* AWB Number with Copy Icon */}
                                                                                    <div className="flex items-center text-sm text-gray-600">
                                                                                        <span className="w-36 font-medium">AWB NO:</span>
                                                                                        <span className="font-semibold">{data?.awb_number ? data?.awb_number : "-"}</span>
                                                                                        {data?.awb_number &&
                                                                                            <MdContentCopy
                                                                                                onClick={() => handleCopy(data?.awb_number, index)}
                                                                                                className="ml-2 text-lg text-blue-500 cursor-pointer hover:text-blue-600 transition duration-200"
                                                                                            />
                                                                                        }
                                                                                    </div>

                                                                                    {/* Copy Success Message */}
                                                                                    {copySuccess[index] && (
                                                                                        <p className="text-green-500 text-xs mt-1">Copied to clipboard!</p>
                                                                                    )}

                                                                                    {/* COD Message */}
                                                                                    {data?.payment_type === 'cod' && (
                                                                                        <div className="flex items-center text-sm font-bold text-slate-800">
                                                                                            <span className="w-36">COD Collectible:</span>
                                                                                            <span>₹{data?.ProductPrice}</span>
                                                                                        </div>
                                                                                    )}

                                                                                    {/* Total Amount */}
                                                                                    {/* <div className="flex items-center text-md font-bold text-slate-800">
                                                                                        <span className="w-36">Total Amount:</span>
                                                                                        <span>₹{Math.round(data?.order_amount || 0)}</span>
                                                                                    </div> */}
                                                                                </div>

                                                                                {/* Shipment Date */}
                                                                                <p className="text-sm text-gray-500 mt-3">{moment(data?.createdAt).format('DD/MM/YYYY')}</p>
                                                                            </div>



                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                {GetOrderOrder?.getOrders?.count === 0 &&
                                                    <div className='my-20'>
                                                        <NoDataFound />
                                                    </div>}
                                            </div>
                                        </>
                                    </div>
                                    {GetOrderOrder?.getOrders?.count > 0 && (
                                        <CustomPagination
                                            totalItems={GetOrderOrder?.getOrders?.count || 0} // Total number of items
                                            limit={limit}
                                            pageNo={page} // Current page number (zero-based index)
                                            handlePageClick={handlePageClick} // Handler to change page
                                        />)}
                                    <div className='lg:hidden py-3 bg-white rounded-lg px-4 cursor-pointer'>
                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"To Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "To Me," it means that the shipment is being sent to you.
                                                Someone else (the sender) has created an order or package and is shipping it to your address.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you order a product online and the seller sends the package to your home or office,
                                                that shipment is "To Me." You are the recipient of the Shipment.
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">"From Me"</h2>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Meaning:</strong> When a shipment is labeled "From Me," it means that you are the one sending the shipment
                                                to someone else. You create the order, prepare the package, and arrange for the Shipment to deliver it to the recipient.
                                            </p>
                                            <p className="mb-4 text-slate-700 font-normal">
                                                <strong className='text-slate-800 font-semibold'>Example:</strong> If you need to send a document to a client or a package to a friend, you create the
                                                shipment, label it, and the Shipment delivers it to the recipient. In this case, the shipment is "From Me."
                                            </p>
                                        </section>

                                        <section className="mb-8">
                                            <h2 className="text-lg font-semibold mb-2">Application in a Shipment Business</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Tracking:</strong> You may need to track both incoming and outgoing shipments...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Customer Service:</strong> When interacting with customers, it’s important to clarify...</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>Logistics Management:</strong> Managing the flow of shipments in both directions helps...</li>
                                            </ul>
                                        </section>

                                        <section>
                                            <h2 className="text-lg font-semibold mb-2">Summary</h2>
                                            <ul className="list-disc pl-6 space-y-2">
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>To Me:</strong> Refers to shipments sent to you from another sender.</li>
                                                <li className="text-slate-700 font-normal"><strong className='text-slate-800 font-semibold'>From Me:</strong> Refers to shipments you send to another recipient.</li>
                                            </ul>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
                {/* <Label /> */}
            </div>
            {/* <div id="label" style={{ visibility: 'hidden', position: 'absolute', top: '-9999px' }}>
                <CustomLabel ref={invoiceRef} order={singleOrderLabel} />
            </div> */}
            {/* <Footer /> */}
        </>
    )
}

export default AllOrders
